import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from "@angular/router";
import { map, Observable } from "rxjs";
import { ApplicationContextService } from "src/app/services/application-context.service";

/**
 * Allows access to the Do Not Call / Do Not Email list routes for full admins OR
 * non-admin users who have been granted the granular "Access Dnc List" role permission
 * (userPermissions.accessDncList). The single accessDncList permission governs both the
 * Do Not Call and Do Not Email lists. Mirrors CanActivateBroadcastManagerRoutesGuard.
 */
@Injectable({
  providedIn: 'root'
})
export class CanActivateDncListAccessGuard {

  constructor(private readonly _applicationContextService: ApplicationContextService,
    private readonly _router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this._applicationContextService.context.pipe(map(context => {
      if (!(context.userPermissions.admin || context.userPermissions.accessDncList)) {
        this._router.navigateByUrl('admin/dashboardv2');
        return false;
      }
      return true;
    }))
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivate(next, state);
  }
}
